/**
 * Odznak testovacího prostředí — bliká v pravém horním rohu, aby bylo na první
 * pohled poznat, že instance není ostrá.
 *
 * Prostředí se čte z <meta name="app-env">, kterou plní welcome.blade.php
 * z `config('app.env')`. Produkce má `production`, stage `staging`.
 *
 * Ptáme se schválně na „není produkce" místo na „je staging": kdyby se
 * APP_ENV rozbilo nebo chybělo, odznak se radši ukáže navíc, než aby na
 * neostré instanci nesvítil vůbec. Na produkci se nevykreslí nic — vrací null,
 * takže v DOM po něm nezbyde ani prázdný prvek.
 *
 * Vykresluje se v app.jsx až za <App />, tedy i nad přihlašovací obrazovkou:
 * že jsem na testu potřebuju vědět dřív, než se přihlásím.
 */
export default function TestOdznak() {
    const env = document.querySelector('meta[name="app-env"]')?.content?.trim() ?? '';

    if (!env || env === 'production') return null;

    return (
        <div className="test-odznak" aria-hidden="true">
            <span className="test-odznak-tecka" />
            TEST
        </div>
    );
}
